import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from '@material-ui/core/TextField';
import useMediaQuery from "@material-ui/core/useMediaQuery";
import {useTheme, makeStyles, withStyles} from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from '@material-ui/icons/Delete';

const StyledTooltip = withStyles({
    tooltip: {
        color: "#ffffff",
        backgroundColor: "#7ab79e"
    }
})(Tooltip);

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`nav-tabpanel-${index}`}
            aria-labelledby={`nav-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
};

function a11yProps(index) {
    return {
        id: `nav-tab-${index}`,
        "aria-controls": `nav-tabpanel-${index}`
    };
}

function LinkTab(props) {
    return (
        <Tab
            component="a"
            onClick={event => {
                event.preventDefault();
            }}
            {...props}
        />
    );
}

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper
    }
}));

function getFormattedDate() {

    const now = new Date();
    const date = [now.getMonth() + 1, now.getDate(), now.getFullYear()];
    const time = [now.getHours(), now.getMinutes(), now.getSeconds()];
    const suffix = (time[0] < 12) ? "AM" : "PM";
    time[0] = (time[0] < 12) ? time[0] : time[0] - 12;
    time[0] = time[0] || 12;
    for (let i = 1; i < 3; i++) {
        if (time[i] < 10) {
            time[i] = "0" + time[i];
        }
    }
    return date.join("_") + "_" + time.join("_") + "_" + suffix;
}

export default function PgnFenDialog(props) {
    const theme = useTheme();
    const classes = useStyles();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const [value, setValue] = React.useState(0);
    const [fileName, setFileName] = React.useState("game_" + getFormattedDate() + ".pgn");

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleClose = () => {
        if(props.mode === "import"){
            if (value) {
                props.onSetFen();
            } else {
                props.onSetPgn();
            }
        } else {
            props.onDownloadPGN(fileName)
        }

    };

    const onChangeFileName = (e) => {
      setFileName(e.target.value);
    }

    return (
        <Dialog
            fullScreen={fullScreen}
            fullWidth
            open={true}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
        >
            <DialogContent>
                {props.mode === "import" ? <div className={classes.root}>
                    <AppBar position="static">
                        <Tabs
                            variant="fullWidth"
                            value={value}
                            onChange={handleChange}
                            aria-label="nav tabs example"
                        >
                            <LinkTab label="PGN" href="/drafts" {...a11yProps(0)} />
                            <LinkTab label="FEN" href="/trash" {...a11yProps(1)} />
                        </Tabs>
                    </AppBar>
                    <TabPanel value={value} index={0}>
                        <StyledTooltip title={"Clear"} placement="left">
                            <IconButton
                                color="primary"
                                style={{right: 25, position: "absolute"}}
                                onClick={props.clearPGN}
                            >
                                <DeleteIcon/>
                            </IconButton>
                        </StyledTooltip>
                        <TextField
                            id="filled-textarea"
                            label="Pgn"
                            multiline
                            fullWidth
                            rows={5}
                            value={props.pgn}
                            onChange={props.onChangePgn}
                        />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <StyledTooltip title={"Clear"} placement="left">
                            <IconButton
                                color="primary"
                                style={{right: 25, position: "absolute"}}
                                onClick={props.clearFEN}
                            >
                                <DeleteIcon/>
                            </IconButton>
                        </StyledTooltip>
                        <TextField id="standard-search"
                                   label="Fen"
                                   value={props.fen}
                                   onChange={props.onChangeFen}
                                   fullWidth/>
                    </TabPanel>
                </div> : <div className={classes.root}>
                  <TextField id="standard-search"
                             label="PGN File Name"
                             value={fileName}
                             onChange={onChangeFileName}
                             fullWidth/>
                </div>
                }

            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleClose} color="primary">
                    {props.mode}
                </Button>
                <Button onClick={props.closeDialog} color="primary" autoFocus>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
}
